class VariantSelects extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange () {
    console.log("On Variant Change: "+this.currentVariant)
    this.updateOptions()
    this.updateMasterId()
    this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.setAvailability(false)
    } else {
      if (this.dataset.isSpeculator) {
        this.updateButtonUrl()
      } else {
        this.updateProductDrawer()
        this.updateMedia()
        this.updateVariantImages()
        this.updateRenders()
        this.updateURL()
        this.updateVariantInput()
        this.renderProductInfo()
        this.setAvailability(this.currentVariant.available)

        const variantUpdated = new Event('variantUpdated', { bubbles: true })
        this.dispatchEvent(variantUpdated)
      }
    }
  }

  updateProductDrawer () {
    if (!this.currentVariant) return

    const lensSkuInput = window.BAO.utils.getElement(
      `[name="default-lens-sku-${this.currentVariant.id}"]`
    )
    if (!lensSkuInput) return

    const lensColoursContainer = window.BAO.utils.getElement(
      '[data-product-wizard-form-el="lens-colours"]'
    )
    if (!lensColoursContainer) return

    const options = window.BAO.utils.getElements(`.prd-Colours_OptionButton`, {
      context: lensColoursContainer,
    })
    const option = options.find(option =>
      option.dataset.value.includes(lensSkuInput.value)
    )
    if (!option) return

    option.dispatchEvent(new Event('click', { bubbles: true }))
  }

  updateOptions () {
    this.options = Array.from(
      this.querySelectorAll('select'),
      select => select.value
    )
    const colourOptionLabel = document.getElementsByClassName(
      'prd-Options_LabelValue'
    )

    for (let i = 0; i < colourOptionLabel.length; ++i) {
      const item = colourOptionLabel[i]

      if (this.options.length > 1) {
        item.innerHTML = this.options[1]
      }
    }
  }

  updateMasterId () {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia () {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return

    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${
        this.currentVariant.featured_media.id
      }"]`
    )
    if (!newMedia) return
    const parent = newMedia.parentElement
    parent.prepend(newMedia)
    window.setTimeout(() => {
      parent.scroll(0, 0)
    })
  }

  updateVariantImages () {
    if (!this.currentVariant) return

    const colour = this.currentVariant[
      `option${this.getColourOptionIndex() + 1}`
    ]
    if (!colour) return

    const mediaItems = window.BAO.utils.getElements(
      `.prd-Media_Item:not(.prd-Media_Item-additional)`
    )
    mediaItems
      .map(el => {
        el.hidden = el.dataset.colour !== colour
        el.classList.remove('prd-Media_Item-firstActive')

        return el
      })
      .some(el => {
        if (el.dataset.colour === colour) {
          el.classList.add('prd-Media_Item-firstActive')

          return true
        }
      })

    if (mediaItems.every(i => i.hidden)) {
      mediaItems[0].hidden = false
      mediaItems[0].classList.add('prd-Media_Item-firstActive')
    }
    if (this.productGallery) {
      if (this.productGallery.carousel) {
        const galleryItems = window.BAO.utils.getElements(
          '.prd-Gallery_Item:not(.prd-Gallery_Item-additional'
        )
        galleryItems.forEach(item =>
          item.classList.toggle(
            'prd-Gallery_Item-active',
            item.dataset.colour === colour
          )
        )

        this.productGallery.reinitialiseCarousel()
      }
    }

    this.updateShowcaseImage(colour)
  }

  updateRenders () {
    if (!this.currentVariant) return

    if (this.getColourOptionIndex() === -1) return

    const colour = this.currentVariant.sku.split('-')[
      this.currentVariant.sku.split('-').length - 1
    ]

    this.threeDRenders.forEach(el => el.setAttribute('frame-colour', colour))
  }

  updateURL () {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateButtonUrl () {
    if (!this.currentVariant) return

    const goToProductButton = window.BAO.utils.getElement(
      '[data-product-go-to-product]'
    )

    goToProductButton.href = `${this.dataset.url}?variant=${
      this.currentVariant.id
    }`
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability () {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo () {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        // eslint-disable-next-line no-unused-expressions
        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
      })
  }

  setAvailability (isAvailable) {
    const addToBagButtons = window.BAO.utils.getElements(
      '[data-product-add-to-cart]'
    )
    const addToBagTexts = window.BAO.utils.getElements(
      '[data-product-add-to-cart-text]'
    )

    const backInStockButtons = window.BAO.utils.getElements(
      '[data-product-back-in-stock-button]'
    )

    addToBagButtons.forEach(addToBagButton => {
      isAvailable
        ? addToBagButton.removeAttribute('disabled')
        : addToBagButton.setAttribute('disabled', null)

      addToBagButton.setAttribute(
        'aria-hidden',
        !backInStockButtons ? false : !isAvailable
      )
    })

    addToBagTexts.forEach(addToBagText => {
      addToBagText.textContent = isAvailable
        ? window.variantStrings.addToCart
        : window.variantStrings.unavailable
    })

    if (!backInStockButtons) return

    backInStockButtons.forEach(backInStockButtons => {
      backInStockButtons.setAttribute('aria-hidden', isAvailable)
      backInStockButtons.setAttribute(
        'data-variant-id',
        this.currentVariant?.id
      )
    })
  }

  getVariantData () {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
        ?.variants
    return this.variantData
  }

  getColourOptionIndex () {
    return this.productData.options.findIndex(
      option => option.toLowerCase() === 'colour'
    )
  }

  updateShowcaseImage (colour) {
    if (!window.customLenses?.frame) {
      return
    }
    const showcaseImage = document.querySelector('.prd-Wizard_ShowcaseImage')
    const lensImage = document.querySelector('.prd-Wizard_ImageLens')
    let frameImage

    window.customLenses.frame.forEach(frame => {
      if (frame.frameColour !== colour || frameImage) {
        return
      }

      frameImage = frame.frameImage

      showcaseImage.setAttribute('data-sunglasses-clear', frameImage)

      if (lensImage && frame.lensPosition && frame.lensScale) {
        lensImage.style.transform = `translate(${frame.lensPosition}) scale(${
          frame.lensScale
        })`
      } else if (lensImage && frame.lensPosition) {
        lensImage.style.transform = `translate(${frame.lensPosition})`
      }
    })
  }

  get productData () {
    return JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
  }

  get threeDRenders () {
    return window.BAO.utils.getElements('three-d-render')
  }

  get productGallery () {
    return document.querySelector('product-gallery')
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        radio => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)


document.querySelectorAll('.prd-ColoursCarousel_Colour').forEach((el, i) => {
  el.addEventListener('click', ()=>{
    document.querySelector('.prd-Options_LabelValue').textContent = el.getAttribute('data-value')
  })
});